import { Injectable, Injector } from '@angular/core';

import { BitfAppSessionService } from '@bitf/services/app-session/bitf-app-session.service';
import { BitfLogDnaSenderService } from '@bitf/services/logger/bitf-log-dna-sender.service';

import { ResponsiveService } from '@services';

@Injectable({
  providedIn: 'root',
})
export class AppSessionService extends BitfAppSessionService {
  constructor(
    private bitfLogDnaSenderService: BitfLogDnaSenderService,
    private responsiveService: ResponsiveService,
    protected injector: Injector
  ) {
    super(injector);
  }

  async init() {
    await super.init();

    // NOTE: needed for mobile/desktop rounting support
    // initDynamicLayoutUrl(this.router, this.storeService);
    this.initBreakpointListener();
    // this.responsiveService.init();
    // --------------------------

    // this.bitfTagManagerService.init();
    this.bitfLogDnaSenderService.init();
    this.responsiveService.init();
  }

  initLogSender() {
    console.log('initLogSender, Implement me');
  }
}
